import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';
import { PrivacyNoticeService } from '../services/privacy-notice.service';

@Injectable({
  providedIn: 'root',
})
export class PrivacyNoticeGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly privacyNoticeService = inject(PrivacyNoticeService);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    const disableGuards = (environment as any).disableAuthGuards;
    if (disableGuards && !environment.production) {
      return true;
    }

    const user = this.authService.getCurrentUser();
    const roles = user?.roles || [];
    const isProfessionalUser = roles.includes('professional') || roles.includes('collaborator');

    if (!isProfessionalUser) {
      return true;
    }

    if (state.url.startsWith('/axa/professionals-privacy-notice')) {
      return true;
    }

    if (this.privacyNoticeService.isAcknowledgedInCache()) {
      return true;
    }

    try {
      const status = await firstValueFrom(this.privacyNoticeService.getStatus());
      if (status.acknowledged) {
        return true;
      }

      return this.router.createUrlTree(['/axa/professionals-privacy-notice'], {
        queryParams: { returnUrl: state.url },
      });
    } catch (error) {
      console.warn('⚠️ Privacy notice check failed, allowing navigation until core API is available.', error);
      return true;
    }
  }
}